import { IOnInit } from "angular";

export class MachineConfigurationTypeDetailViewComponentController
  implements IOnInit
{
  readonly machineConfigurationType: any;

  static $inject = [];

  $onInit() {}
}
